var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"flex flex-col mt-5"},[(_vm.label)?_c('span',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"mt-1"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }